import {useState} from 'react'

// Open/closed state for the collapsible "Grupo - Álbum individual" rows in the
// code tables. Groups start collapsed, as in the design.
export function useExpandedGroups() {
    const [expanded, setExpanded] = useState<Set<string>>(new Set())
    const toggle = (key: string) => setExpanded((current) => {
        const next = new Set(current)
        if (next.has(key)) next.delete(key)
        else next.add(key)
        return next
    })
    return {isExpanded: (key: string) => expanded.has(key), toggle}
}
